import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchEbmSaleRecords } from '@/renderer/services/ebmSaleRecordsService';
import type { EbmSaleRecordsFilterParams } from '@/renderer/types/pagination';

export function useEbmSaleRecords(params: EbmSaleRecordsFilterParams) {
  return useQuery({
    queryKey: queryKeys.ebm.saleRecords(params),
    queryFn: async () => {
      const result = await fetchEbmSaleRecords(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch EBM sale records');
      }
      return result.data;
    },
    // A null/undefined outletId is a valid company-wide view, not "not ready
    // yet" — always enabled.
    placeholderData: keepPreviousData,
  });
}
